import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class ForestWhispering5PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.FOREST_WHISPERING5;
}

export default ForestWhispering5PoiTileEntity;
